import { useState, useRef, CSSProperties, useEffect, memo } from 'react';
import { message as toast } from 'antd';
import LottieContainer from '@/components/lottie-container';
import { knowledge_collect_state, luca_common_collect } from '@/apis/qa';
import { old_comm_collect } from '@/apis';
import { toastInQa } from '@/utils/qa';
import { getQaStore } from '@/store/qa';
import classNames from 'classnames';
import './index.scss';

interface IProps {
    initState?: boolean;
    lucaCommId?: number;
    recordId?: string;
    qaId?: string;
    askId?: number;
    needToastInQa?: boolean;
    className?: string;
}

const CollectAction = ({ initState, lucaCommId, recordId, qaId, askId, needToastInQa, className }: IProps) => {
    const animatingRef = useRef(false);
    const [collected, setCollected] = useState(false);

    const styles = useRef<Record<string, CSSProperties>>({
        collected: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 2px',
            cursor: 'pointer',
            fontWeight: 600,
            color: '#9655FF',
            borderRadius: '6px',
        },
        notCollected: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 2px',
            cursor: 'pointer',
            fontWeight: 600,
            color: '#1B1B48',
            borderRadius: '6px',
        },
        notCollectePng: {
            width: '20px',
            height: '20px',
            background: "url('https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/28/6eba8_20240828155655.png') center/19px 19px",
        },
        collectText: {
            marginLeft: '4px',
        },
    });

    const getCollectState = async (recordId: string) => {
        const { result } = await knowledge_collect_state({ recordId });
        setCollected(result);
    };

    const handleCollect = async (collectFlag: boolean) => {
        animatingRef.current = collectFlag;
        setCollected(collectFlag);
        const { projectId, subjectId, twoLevelSubjectId } = getQaStore()?.qaConfig || {};
        const { status, message } = lucaCommId
            ? await luca_common_collect({ id: lucaCommId, collectFlag })
            : recordId
            ? await luca_common_collect({ recordId, collectFlag, projectId, subjectId, twoLevelSubjectId })
            : qaId
            ? await luca_common_collect({ qaId, collectFlag })
            : await old_comm_collect({ ask_id: askId! });
        if (status !== 0) {
            needToastInQa ? toastInQa(message || '') : toast.warning(message);
            animatingRef.current = !collectFlag;
            setCollected(!collectFlag);
        } else {
            lucaCommId && getQaStore()?.updateQaConfig({ collectFlag });
        }
    };

    useEffect(() => {
        recordId && getCollectState(recordId);
    }, [recordId]);

    useEffect(() => {
        if (typeof initState === 'boolean') {
            setCollected(initState);
        }
    }, [initState]);

    return (
        <div
            className={classNames('collect-action', collected && 'collect-action--selected', className)}
            style={collected ? styles.current.collected : styles.current.notCollected}
            onClick={() => handleCollect(!collected)}
        >
            {collected ? (
                <LottieContainer
                    type="collect"
                    autoplay={true}
                    excuteType={animatingRef.current ? 'autoPlayByInit' : 'directCompletion'}
                    width={21}
                    height={21}
                />
            ) : (
                <div style={styles.current.notCollectePng} />
            )}
            <span style={styles.current.collectText}>{collected ? '已收藏' : '收藏'}</span>
        </div>
    );
};

export default memo(CollectAction);
